import { useTranslation } from "react-i18next";
import React, { useState } from "react";

import { ChapterStatsDto, LessonStatsDto } from "../../interfaces";
import { OrganizingChaptersPage } from "./OrganizingChaptersPage";
import { useParams } from "react-router-dom";

export const OrganizingLayoutPage = () => {
  //#region hooks
  const { t, i18n } = useTranslation();
  const { subjectId } = useParams<any>();
  //#endregion

  //#region internal state
  const [page, setPage] = useState<number>(1);
  const [selectedChapterStats, setSelectedChapterStats] =
    useState<ChapterStatsDto | null>(null);
  const [selectedLessonStats, setSelectedLessonStats] =
    useState<LessonStatsDto | null>(null);
  //#endregion

  document.title = `${t("documentTitle", { pageName: "skills" })}`;

  //#region handlers

  //#endregion

  const getHeader = () => {
    try {
      return (
        <React.Fragment>
          <span className="cursor-pointer" onClick={() => setPage(1)}>
            {t("questionsStats")}
          </span>
          {i18n.language === "ar" ? (
            <i className="ri-arrow-left-s-line align-bottom text-muted"></i>
          ) : (
            <i className="ri-arrow-right-s-line align-bottom text-muted"></i>
          )}
          <span className="text-muted">
            {i18n.language === "ar"
              ? selectedChapterStats?.name.ar
              : selectedChapterStats?.name.en}
          </span>
          {i18n.language === "ar" ? (
            <i className="ri-arrow-left-s-line align-bottom text-muted"></i>
          ) : (
            <i className="ri-arrow-right-s-line align-bottom text-muted"></i>
          )}
          <span className="text-muted">
            {i18n.language === "ar"
              ? selectedLessonStats?.name.ar
              : selectedLessonStats?.name.en}
          </span>
        </React.Fragment>
      );
    } catch (exception: any) {
      return t("question");
    }
  };

  //#endregion

  return (
    <React.Fragment>
      {page === 1 && <OrganizingChaptersPage subjectId={subjectId} />}
    </React.Fragment>
  );
};
